import React from 'react';

export default function EmailVerify() {
  return (
    <div style={{padding: '2rem'}}>
      <h2>Email Verification</h2>
      <p>Please check your school email for a verification link and follow the instructions to activate your account.</p>
    </div>
  );
}
